/* TT buy box: pack/kit selection, gift locks, gallery, add to cart, sticky bar. */
(function () {
  document.querySelectorAll('[data-ttb]').forEach(function (root) {
    var json = function (sel) { var el = root.querySelector(sel); try { return JSON.parse(el.textContent); } catch (e) { return null; } };
    var variants = json('[data-ttb-variants]') || [];
    var fixed = json('[data-ttb-fixed]') || {};
    var packs = [].slice.call(root.querySelectorAll('[data-ttb-pack]'));
    var gifts = [].slice.call(root.querySelectorAll('[data-ttb-gift]'));
    var big = root.querySelector('[data-ttb-big]');
    var ctaBtn = root.querySelector('[data-ttb-cta]'), ctaText = root.querySelector('[data-ttb-ctatext]');
    var bar = root.querySelector('[data-ttb-sticky]');
    var cur = Math.min(+root.getAttribute('data-default') || 0, packs.length - 1);

    function pick(list, i) { var p = (list || '').split('|'); return (p[Math.min(i, p.length - 1)] || '').trim(); }

    // gallery
    root.querySelectorAll('[data-ttb-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-ttb-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
        if (big) big.src = t.getAttribute('data-src');
      });
    });

    function rows() {
      var p = packs[cur]; if (!p) return [];
      return [].slice.call(p.querySelectorAll('[data-ttb-row]')).map(function (r) {
        var a = r.querySelector('[data-ttb-o1]'), b = r.querySelector('[data-ttb-o2]');
        return { o1: a ? a.value : null, o2: b ? b.value : (fixed.o2 || null),
                 t1: a ? a.options[a.selectedIndex].text : '', t2: b ? b.options[b.selectedIndex].text : '' };
      });
    }
    function variantFor(o1, o2) {
      var ok = function (v) { return (o1 == null || v.o1 === o1) && (o2 == null || v.o2 === o2); };
      return variants.filter(function (v) { return ok(v) && v.a; })[0] || variants.filter(ok)[0] ||
             variants.filter(function (v) { return v.a; })[0] || variants[0];
    }

    function render() {
      packs.forEach(function (p, i) {
        p.classList.toggle('is-on', i === cur);
        var b = p.querySelector('[data-ttb-select]'); if (b) b.setAttribute('aria-pressed', i === cur ? 'true' : 'false');
      });
      gifts.forEach(function (g) {
        var locked = cur + 1 < (+g.getAttribute('data-unlock') || 1);
        g.classList.toggle('is-locked', locked);
        var v = pick(g.getAttribute('data-values'), cur), l = pick(g.getAttribute('data-labels'), cur);
        var gv = g.querySelector('[data-ttb-gval]'), gl = g.querySelector('[data-ttb-glabel]');
        if (gv) gv.innerHTML = v ? 'FREE <s>' + v + '</s>' : 'FREE';
        if (gl) gl.textContent = l;
      });
      var p = packs[cur];
      if (ctaText && p) ctaText.textContent = p.getAttribute('data-cta') || 'Add to cart';
      syncBar();
    }

    function syncBar() {
      if (!bar) return;
      var p = packs[cur], r = rows()[0];
      var l = bar.querySelector('[data-ttb-slabel]'), s = bar.querySelector('[data-ttb-ssub]');
      if (l && p) l.textContent = p.getAttribute('data-sticky') || '';
      if (s) s.textContent = r ? [r.t1, r.t2].filter(Boolean).join(' · ') : '';
    }

    packs.forEach(function (p, i) {
      var b = p.querySelector('[data-ttb-select]');
      if (b) b.addEventListener('click', function () { cur = i; render(); });
    });
    root.addEventListener('change', syncBar);

    // Open the cart drawer with the fresh cart (Dawn's renderContents); fall back to the cart page.
    function showCart(state) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && state && state.sections && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); drawer.renderContents(state); return true; }
      window.location.href = '/cart'; return false;
    }

    var busy = false;
    function add(btn) {
      if (busy || !packs[cur]) return; busy = true;
      var counts = {};
      rows().forEach(function (r) { var v = variantFor(r.o1, r.o2); if (v) counts[v.id] = (counts[v.id] || 0) + 1; });
      if (!Object.keys(counts).length) { var v0 = variantFor(null, fixed.o2 || null); if (v0) counts[v0.id] = 1; }
      packs[cur].querySelectorAll('[data-ttb-kitvar]').forEach(function (li) {
        var id = li.getAttribute('data-ttb-kitvar'); if (id) counts[id] = (counts[id] || 0) + 1;
      });
      var label = (packs[cur].getAttribute('data-sticky') || '').split(' · ')[0];
      var packId = Date.now().toString(36) + Math.random().toString(36).slice(2, 6); // groups this pack's lines in the cart drawer
      var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id], properties: { _offer: label, _pack_id: packId } }; });
      var old = btn.innerHTML; btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
        .then(function (state) { busy = false; btn.removeAttribute('aria-busy'); showCart(state); })
        .catch(function (e) {
          busy = false; btn.removeAttribute('aria-busy'); btn.textContent = e.message || 'Could not add to cart, please try again';
          setTimeout(function () { btn.innerHTML = old; }, 3500);
        });
    }
    if (ctaBtn) ctaBtn.addEventListener('click', function (e) { e.preventDefault(); add(ctaBtn); });
    var sbtn = bar && bar.querySelector('[data-ttb-sbtn]');
    if (sbtn) sbtn.addEventListener('click', function (e) { e.preventDefault(); add(sbtn); });

    if (bar && ctaBtn) {
      var ticking = false;
      var place = function () { ticking = false; bar.classList.toggle('is-on', ctaBtn.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(place); } }, { passive: true });
      window.addEventListener('resize', place); place();
    }
    render();
  });
})();
